import React from "react";
import { CardContent, Grid, List, ListItem, ListItemSecondaryAction, ListItemText } from "@material-ui/core";
import { CardPageItem } from "../../../custom/Page";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import DarkBar from "../DarkBar";

const SummaryUserCountBySituationSection = ({ summary, title, pathname, isForAgents = false, role }) => {
  if (!summary) return null;
  const customerSituations = ["NEW", "INACTIVE", "ACTIVE", ...(isForAgents ? [] : ["INAPT"])];
  return (
    <CardPageItem raised margin={1}>
      <DarkBar text={title} />
      <CardContent>
        <List>{customerSituations.map((situation) => getSituationCountListItem(situation, summary, pathname, isForAgents, role))}</List>
      </CardContent>
    </CardPageItem>
  );
};

const getSituationCountListItem = (label, summary, pathname, isForAgents, role) => {
  let search = isForAgents ? `?agentSituation=${label}` : `?customerSituation=${label}`;
  search += role ? `&role=${role}` : "";

  return (
    <ListItem key={label} button component={Link} to={{ pathname: pathname, search: search }}>
      <ListItemText primary={<FormattedMessage id={`app.enuns.${label}`} />} />
      {summary?.[label] ? (
        summary[label] > 1 ? (
          <FormattedMessage id={isForAgents ? "app.agents.quantity" : "app.customers.quantity"} values={{ quantity: summary[label] }} />
        ) : (
          <FormattedMessage id={isForAgents ? "app.agents.quantity.one" : "app.customers.quantity.one"} />
        )
      ) : (
        <FormattedMessage id={isForAgents ? "app.agents.quantity.zero" : "app.customers.quantity.zero"} />
      )}
    </ListItem>
  );
};
export default SummaryUserCountBySituationSection;
